import { render } from "./DeliveryStatus.vue?vue&type=template&id=5fdfee75&scoped=true"
import script from "./DeliveryStatus.vue?vue&type=script&lang=js"
export * from "./DeliveryStatus.vue?vue&type=script&lang=js"

import "./DeliveryStatus.vue?vue&type=style&index=0&id=5fdfee75&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fdfee75"]])

export default __exports__